import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthState } from '../state/auth.state';
import { LeaguesState } from '../state/leagues.state';
import { SquadState } from '../state/squad.state';
import { CompetitionService } from '../http/competition.service';

export const leagueGuard: CanActivateFn = async () => {
  const auth = inject(AuthState);
  const leagues = inject(LeaguesState);
  const squad = inject(SquadState);
  const compService = inject(CompetitionService);
  const router = inject(Router);

  if (!auth.currentUser()) {
    return router.createUrlTree(['/login']);
  }

  // Resolver participación real desde GET /api/me/competitions
  try {
    const context = await compService.resolveCurrentCompetitionContext();
    if (context.status === 'JOINED' && context.clubId) {
      const state = await compService.getResolvedCompetitionState();
      leagues.syncWithCompetitions(state);
      return true;
    } else {
      return router.createUrlTree(['/leagues']);
    }
  } catch (err: any) {
    if (err?.status === 401) {
      return router.createUrlTree(['/login']);
    }
    return router.createUrlTree(['/leagues']);
  }
};
